// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_markBuyerNeedInContract(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["BuyerNeedMarkedInContract"]);
}

var variablesConverter = {"markBuyerNeedInContractInput":{},"__root":{"input":{"r":"markBuyerNeedInContractInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"markBuyerNeedInContract_BuyerNeedMarkedInContract_buyerNeed":{"f":""},"markBuyerNeedInContract":{"u":"response_markBuyerNeedInContract"}}};

var wrapResponseConverterMap = {
  response_markBuyerNeedInContract: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"markBuyerNeedInContract_BuyerNeedMarkedInContract_buyerNeed":{"f":""},"markBuyerNeedInContract":{"u":"response_markBuyerNeedInContract"}}};

var responseConverterMap = {
  response_markBuyerNeedInContract: unwrap_response_markBuyerNeedInContract
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangeComment",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "statusChangedAt",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarkBuyerNeedAsInContractDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "markBuyerNeedInContract",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerNeedV5",
                "kind": "LinkedField",
                "name": "buyerNeed",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuyerPageHeader_StatusChangeButton_buyerNeedV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuyerPageStatusCallout_buyerNeedV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClientPageMatchingStatusLabel_matchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "BuyerNeedMarkedInContract",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarkBuyerNeedAsInContractDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "markBuyerNeedInContract",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerNeedV5",
                "kind": "LinkedField",
                "name": "buyerNeed",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isRenewable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeUntil",
                            "storageKey": null
                          }
                        ],
                        "type": "ActiveBuyerNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiredAt",
                            "storageKey": null
                          }
                        ],
                        "type": "ExpiredBuyerNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "withdrawnAt",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "type": "WithdrawnBuyerNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "PurchasedBuyerNeed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "InContractBuyerNeed",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activelyMatching",
                        "storageKey": null
                      }
                    ],
                    "type": "Matchable",
                    "abstractKey": "__isMatchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "BuyerNeedMarkedInContract",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "42ac8fa5a0097b4d2336df467522c560",
    "id": null,
    "metadata": {},
    "name": "MarkBuyerNeedAsInContractDialogMutation",
    "operationKind": "mutation",
    "text": "mutation MarkBuyerNeedAsInContractDialogMutation(\n  $input: MarkBuyerNeedInContractInput!\n) {\n  markBuyerNeedInContract(input: $input) {\n    __typename\n    ... on BuyerNeedMarkedInContract {\n      buyerNeed {\n        ...BuyerPageHeader_StatusChangeButton_buyerNeedV5\n        ...BuyerPageStatusCallout_buyerNeedV5\n        ...ClientPageMatchingStatusLabel_matchable\n        nodeId\n      }\n    }\n  }\n}\n\nfragment BuyerPageHeader_StatusChangeButton_buyerNeedV5 on BuyerNeedV5 {\n  nodeId\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      isRenewable\n    }\n    ... on ExpiredBuyerNeed {\n      __typename\n    }\n    ... on WithdrawnBuyerNeed {\n      __typename\n    }\n    ... on PurchasedBuyerNeed {\n      __typename\n    }\n    ... on InContractBuyerNeed {\n      __typename\n    }\n  }\n}\n\nfragment BuyerPageStatusCallout_buyerNeedV5 on BuyerNeedV5 {\n  nodeId\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      isRenewable\n      ...ExpiringBuyerNeedCallout_activeBuyerNeed\n    }\n    ... on ExpiredBuyerNeed {\n      ...ExpiredBuyerNeedCallout_expiredBuyerNeed\n    }\n    ... on WithdrawnBuyerNeed {\n      ...WithdrawnBuyerNeedCallout_withdrawnBuyerNeed\n    }\n    ... on InContractBuyerNeed {\n      ...InContractBuyerNeedCallout_inContractBuyerNeed\n    }\n    ... on PurchasedBuyerNeed {\n      ...PurchasedBuyerNeedCallout_purchasedBuyerNeed\n    }\n  }\n}\n\nfragment ClientPageMatchingStatusLabel_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  activelyMatching\n}\n\nfragment ExpiredBuyerNeedCallout_expiredBuyerNeed on ExpiredBuyerNeed {\n  expiredAt\n}\n\nfragment ExpiringBuyerNeedCallout_activeBuyerNeed on ActiveBuyerNeed {\n  activeUntil\n}\n\nfragment InContractBuyerNeedCallout_inContractBuyerNeed on InContractBuyerNeed {\n  statusChangeComment\n  statusChangedAt\n}\n\nfragment PurchasedBuyerNeedCallout_purchasedBuyerNeed on PurchasedBuyerNeed {\n  statusChangeComment\n  statusChangedAt\n}\n\nfragment WithdrawnBuyerNeedCallout_withdrawnBuyerNeed on WithdrawnBuyerNeed {\n  withdrawnAt\n  statusChangeComment\n}\n"
  }
};
})());

var wrap_response_markBuyerNeedInContract = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_markBuyerNeedInContract = unwrap_response_markBuyerNeedInContract;
exports.wrap_response_markBuyerNeedInContract = wrap_response_markBuyerNeedInContract;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
